import React, { useState } from 'react'
import { withRouter } from 'react-router-dom'
import * as BrandActions from '../../../redux/actions/brands'
import { Label, Button, Container, Col, Row, Alert } from 'reactstrap'
import { I18n } from 'react-redux-i18n'
import { Formik, Form, Field, ErrorMessage } from 'formik'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { userIsAuthorized } from '../../../routes/Authorizer/helpers'

import SidePopup from '../../SidePopup'
import BrandValidator from './BrandValidator'

const BrandNew = (props) => {
  const [errors, setErrors] = useState({})

  const handleSubmit = (values, { setSubmitting }) => {
    values.company = props.company._id
    props
      .addNewBrand(values)
      .then(() => hideModal())
      .catch((err) => setErrors(typeof err === 'object' ? err : { error: 'server-error' }))
      .finally(() => setSubmitting(false))
  }

  const hideModal = (e) => {
    if (e) e.preventDefault()
    props.history.goBack()
  }

  const { capabilities } = props

  return (
    <SidePopup onHide={hideModal}>
      <Formik initialValues={Object.assign({}, { name: '' })} validate={BrandValidator} onSubmit={handleSubmit}>
        {({ isSubmitting }) => (
          <Form>
            <Container className='px-0 pt-3'>
              <Row>
                <Col xs={12}>
                  <div className='section-title'>{I18n.t('brand.new')}</div>
                </Col>
              </Row>
              <Row className='no-gutters'>
                <Col xs={12}>
                  <Label for='brand.name' className='required'>
                    {I18n.t('dashboard_name')}
                  </Label>
                  <Field id='brand.name' type='text' name='name' className='form-control' />
                  <ErrorMessage name='name' component='small' className='text-danger' />
                </Col>
              </Row>

              {Object.keys(errors).length > 0 && (
                <Row className='mt-3'>
                  {Object.keys(errors).map((e, i) => (
                    <Col key={i} xs={12}>
                      <Alert color='danger'>{I18n.t(`dashboard_errors_${errors[e]}`)}</Alert>
                    </Col>
                  ))}
                </Row>
              )}

              <Row className='no-gutters mt-3'>
                <Col>
                  <Button disabled={isSubmitting} onClick={hideModal} color='default'>
                    {I18n.t('dashboard_cancel')}
                  </Button>
                </Col>
                {userIsAuthorized({ capabilities: capabilities.brands, action: 'CREATE' }) && (
                  <Col className='text-right'>
                    <Button disabled={isSubmitting} type='submit' color='primary'>
                      {I18n.t('dashboard_save')}
                    </Button>
                  </Col>
                )}
              </Row>
            </Container>
          </Form>
        )}
      </Formik>
    </SidePopup>
  )
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Object.assign({}, BrandActions), dispatch)
}

function mapStateToProps(state) {
  return { company: state.companies }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BrandNew))
